// ─── Components ──────────────────────────────────────────────────
import WithdrawalHistoryShimmer from "../withdrawalHistoryShimmer";
import WithdrawalHistoryItem from "../withdrawalHistoryItem";

// styles
import styles from "./styles.module.scss";

// ─── Hooks & Providers ──────────────────────────────────────────
import { useWallet } from "../../../../providers/wallet/wallet.provider";
import Spinner from "../../../../components/common/Spinner";

interface BulkListProps {
  showMobileView?: boolean;
}

const BulkList = ({ showMobileView }: BulkListProps) => {
  // ─── Wallet State from Provider ──────────────────────────────
  const withdrawalHistory = useWallet((state) => state.withdrawalHistory);
  const withdrawalHistoryLoading = useWallet(
    (state) => state.withdrawalHistoryLoading
  );

  // ─── Render Logic ─────────────────────────────────────────────
  return (
    <>
      {withdrawalHistoryLoading && withdrawalHistory.length === 0 ? (
        // Initial loading state for withdrawal history
        <WithdrawalHistoryShimmer />
      ) : withdrawalHistory.length === 0 ? (
        // Empty state for withdrawal history
        <div className={styles["center_container"]}>
          <img
            src="/assets/images/svg/empty_balance.svg"
            alt="Empty withdrawal history"
            className="empty_wallet_image"
          />
        </div>
      ) : (
        // Withdrawal history list
        <div className={styles.withdrawal_items_list}>
          {withdrawalHistory.map((withdrawal) => (
            <WithdrawalHistoryItem
              key={withdrawal.withdrawalNumber}
              withdrawal={withdrawal}
              showMobileView={showMobileView}
            />
          ))}

          {withdrawalHistoryLoading && withdrawalHistory.length > 0 && (
            <div className={styles["center_container--load_more"]}>
              <Spinner />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default BulkList;
